import React from 'react';

import { Box, Text } from '@simplybusiness/mobius-core';
import CustomerServiceContact from './CustomerServiceContact';

const UnexpectedError = () => (
  <Box maxWidth={766} style={{ textAlign: 'center', width: '100%' }}>
    <Text
      component="h1"
      marginTop={0}
      marginBottom={33}
      fontSize={50}
      fontWeight={700}
    >
      Oops!
    </Text>
    <Text fontSize={20} lineHeight="30px" margin={0}>
      Something went wrong to tell us your Employer PAYE Reference Number
    </Text>
    <Text fontSize={20} lineHeight="30px" margin={0}>
      (also known as Employer Reference Number (ERN))
    </Text>
    <Text fontSize={20} lineHeight="30px" style={{ textTransform: 'lowercase' }} margin={0}>
      <CustomerServiceContact />
    </Text>
  </Box>
);

export default UnexpectedError;
